import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

export const ProductGoToActionBlock = ({
  title,
  texts,
  btn,
}: {
  title: string;
  texts: string[];
  btn: ReactNode;
}) => {
  return (
    <Stack
      direction="row"
      gap="16px"
      borderRadius="6px"
      bgcolor="#FFF7E5"
      padding="16px"
      alignItems="flex-start"
      border="1px solid #D9D9D9"
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexGrow={1}
        gap="24px"
      >
        <Stack gap="4px">
          <Typography
            variant="subtitle1"
            color="custom.textDarkBlue"
            sx={{ fontWeight: 500 }}
          >
            {title}
          </Typography>
          {texts.map((text) => (
            <Typography key={text} variant="body1" color="text.secondary">
              {text}
            </Typography>
          ))}
        </Stack>
        {btn}
      </Stack>
    </Stack>
  );
};
